export const hiddenRosTopics = new Set([
    "/formant/command",
    "/formant/ingest",
    "/tf",
    "/tf_static",
]);
